module.exports = __webpack_public_path__ + "608631c0491dc4809657b72347afc1dc.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/AW.svg
// module id = AZML
// module chunks = 0